/**
 * i18next bootstrap.
 *
 * Wired up in Phase 0, before any UI exists, so no screen is ever written with
 * hardcoded text. Retrofitting i18n is what forced the legacy English fork:
 * ~80% of the two apps was identical, and the divergence was almost entirely
 * strings and config.
 *
 * The resolution options live in `@bolao/i18n` so they can be unit tested. Only
 * the browser-specific parts — language detection and the React binding — are
 * configured here.
 */
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { createI18nOptions } from '@bolao/i18n';

export const LOCALE_STORAGE_KEY = 'bolao.locale';

await i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...createI18nOptions(),
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

export default i18next;
